export function stableSceneStringify(value) {
  if (Array.isArray(value)) {
    return `[${value.map(stableSceneStringify).join(',')}]`
  }
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${stableSceneStringify(value[key])}`).join(',')}}`
  }
  return JSON.stringify(value)
}

export function cloneScene(value) {
  if (value == null) return value
  return JSON.parse(JSON.stringify(value))
}

function normalizeSceneNumber(value) {
  const n = Number(value)
  return Number.isFinite(n) ? n : value ?? null
}

function normalizeSceneConfigData(configData = {}) {
  const config = { ...(configData || {}) }
  const numericKeys = [
    'width',
    'height',
    'wall_offset_x',
    'wall_offset_y',
    'artwork_scale_x',
    'artwork_scale_y',
    'artwork_rotation',
    'artwork_offset_left',
    'artwork_offset_top',
  ]
  numericKeys.forEach(key => {
    if (config[key] != null) config[key] = normalizeSceneNumber(config[key])
  })
  return config
}

export function normalizeSceneItems(items = [], { projectId = null } = {}) {
  return (Array.isArray(items) ? items : []).map((item, index) => {
    const sceneItem = cloneScene(item) || {}
    return {
      ...sceneItem,
      item_sort: Number.isFinite(Number(sceneItem.item_sort)) ? Number(sceneItem.item_sort) : index,
      width: normalizeSceneNumber(sceneItem.width),
      height: normalizeSceneNumber(sceneItem.height),
      workspace: sceneItem.workspace || '',
      project_id: sceneItem.project_id ?? sceneItem.project ?? projectId,
      quantity: Number(sceneItem.quantity ?? 1),
      location: sceneItem.location || '',
      note: sceneItem.note || '',
      thumbnail: sceneItem.thumbnail || null,
      config_data: normalizeSceneConfigData(sceneItem.config_data),
    }
  })
}

export function mergeItemPayload(item = {}, payload = {}) {
  return {
    ...item,
    ...payload,
    config_data: {
      ...(item.config_data || {}),
      ...(payload.config_data || {}),
    },
  }
}

